import { useCallback } from 'react';
import { useViewerStore } from '../../../../../store/store';

interface UseDashboardVisibilityArgs {
    isDashboardOpenProp?: boolean;
    setIsDashboardOpenProp?: (next: boolean | ((prev: boolean) => boolean)) => void;
}

export function useDashboardVisibility({
    isDashboardOpenProp,
    setIsDashboardOpenProp,
}: UseDashboardVisibilityArgs) {
    const isDashboardOpenFromStore = useViewerStore((s) => Boolean(s.isDashboardOpen));
    const isDashboardOpen =
        typeof isDashboardOpenProp === 'boolean' ? isDashboardOpenProp : isDashboardOpenFromStore;

    const setIsDashboardOpen = useCallback((next: boolean | ((prev: boolean) => boolean)) => {
        const current =
            typeof isDashboardOpenProp === 'boolean'
                ? isDashboardOpenProp
                : Boolean(useViewerStore.getState().isDashboardOpen);
        const resolved = typeof next === 'function' ? (next as (prev: boolean) => boolean)(current) : next;
        if (resolved === current) return;
        if (setIsDashboardOpenProp) {
            setIsDashboardOpenProp(resolved);
        } else {
            useViewerStore.setState({ isDashboardOpen: resolved });
        }
    }, [isDashboardOpenProp, setIsDashboardOpenProp]);

    return { isDashboardOpen, setIsDashboardOpen };
}
